import api from "./client";

export interface ContactIdentitySummary {
  provider: string;
  label: string | null;
  confidence: string | null;
}

export interface CrmContactSummary {
  crm_contact_id: string;
  status: "active" | "unresolved" | "archived" | string;
  display_name: string | null;
  display_name_source: string | null;
  display_name_confidence: string | null;
  display_name_locked: boolean;
  identity_summary: ContactIdentitySummary[];
  recent_activity_at: string | null;
  booking_count: number;
  conversation_count: number;
  mismatch_count: number;
  possible_match_count: number;
}

export interface CrmContactsListResponse {
  contacts: CrmContactSummary[];
  next_cursor: string | null;
}

export interface CrmContactDetail {
  contact: {
    crm_contact_id: string;
    business_id: string;
    status: string;
    display_name: string | null;
    display_name_source: string | null;
    display_name_confidence: string | null;
    display_name_locked: boolean;
    created_at: string | null;
    last_seen_at: string | null;
  };
  identities: Array<{
    crm_identity_id: string;
    provider: string;
    scope_id: string | null;
    label: string | null;
    confidence: string | null;
    first_seen_at: string | null;
    last_seen_at: string | null;
  }>;
  observations: Array<{
    type: string;
    value: string | null;
    source_channel: string | null;
    confidence: string | null;
    observed_at: string | null;
    source_booking_id: string | null;
  }>;
  bookings: Array<{
    booking_id: string;
    customer_name_snapshot: string | null;
    start_time: string | null;
    status: string | null;
  }>;
  conversations: Array<{
    conversation_id: string;
    channel: string | null;
    primary_display_name: string | null;
    identity_resolution_status: string | null;
    last_activity_at: string | null;
  }>;
  possible_matches: Array<{
    crm_possible_match_id: string;
    reason_code: string;
    confidence: string | number | null;
    created_at: string | null;
  }>;
}

export async function fetchContacts(): Promise<CrmContactsListResponse> {
  const res = await api.get<CrmContactsListResponse>("/contacts");
  return res.data;
}

export async function fetchContactDetail(
  crmContactId: string
): Promise<CrmContactDetail> {
  const res = await api.get<CrmContactDetail>(`/contacts/${crmContactId}`);
  return res.data;
}
